import React from 'react';
import { RotateCw, Crop, ChevronLeft, ChevronRight, Trash2, Loader2, AlertTriangle, Check } from 'lucide-react';

const IconBtn = ({ onClick, title, active, danger, disabled, children, testId }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    aria-label={title}
    disabled={disabled}
    data-testid={testId}
    className={`w-8 h-8 flex items-center justify-center rounded-sm transition-colors disabled:opacity-30 ${
      danger
        ? 'text-rose-600 hover:bg-rose-50'
        : active
          ? 'bg-[#b8893d] text-white'
          : 'text-[#1B3A5C] hover:bg-[#f5f8fa]'
    }`}
  >
    {children}
  </button>
);

export const ScanPageCard = ({ page, index, total, onRotate, onToggleCrop, onMove, onRemove, busy }) => (
  <div
    data-testid={`scan-page-${index}`}
    className="bg-white border border-gray-200 rounded-sm overflow-hidden flex flex-col shadow-sm"
  >
    <div className="relative bg-[#e9eef2] aspect-[3/4] flex items-center justify-center overflow-hidden">
      {page.preview ? (
        <img src={page.preview} alt={`Seite ${index + 1}`} className="max-w-full max-h-full object-contain" />
      ) : page.error ? (
        <div className="text-center px-4">
          <AlertTriangle className="w-8 h-8 text-rose-500 mx-auto mb-2" />
          <p className="text-xs text-rose-600">{page.error}</p>
        </div>
      ) : (
        <img src={page.originalUrl} alt="" className="max-w-full max-h-full object-contain opacity-40" />
      )}
      {page.loading && (
        <div className="absolute inset-0 bg-white/60 flex items-center justify-center">
          <Loader2 className="w-7 h-7 text-[#b8893d] animate-spin" />
        </div>
      )}
      <span className="absolute top-2 left-2 bg-[#1B3A5C] text-white text-[11px] font-semibold w-7 h-7 rounded-full flex items-center justify-center">
        {index + 1}
      </span>
      {page.preview && !page.loading && (
        <span
          data-testid={`scan-page-${index}-status`}
          className={`absolute bottom-2 left-2 text-[10px] tracking-wider px-2 py-0.5 rounded-sm flex items-center gap-1 ${
            page.cropped ? 'bg-emerald-600 text-white' : 'bg-amber-500 text-white'
          }`}
        >
          {page.cropped ? <Check className="w-3 h-3" /> : <AlertTriangle className="w-3 h-3" />}
          {page.cropped ? 'ZUGESCHNITTEN' : page.crop ? 'KEIN RAND ERKANNT' : 'OHNE ZUSCHNITT'}
        </span>
      )}
    </div>
    <div className="flex items-center justify-between px-2 py-1.5 border-t border-gray-100">
      <div className="flex items-center gap-0.5">
        <IconBtn onClick={onRotate} title="Um 90° drehen" disabled={busy} testId={`scan-page-${index}-rotate`}>
          <RotateCw className="w-4 h-4" />
        </IconBtn>
        <IconBtn onClick={onToggleCrop} title={page.crop ? 'Zuschnitt aus' : 'Zuschnitt an'} active={page.crop} disabled={busy} testId={`scan-page-${index}-crop`}>
          <Crop className="w-4 h-4" />
        </IconBtn>
      </div>
      <div className="flex items-center gap-0.5">
        <IconBtn onClick={() => onMove(-1)} title="Nach vorne" disabled={busy || index === 0} testId={`scan-page-${index}-left`}>
          <ChevronLeft className="w-4 h-4" />
        </IconBtn>
        <IconBtn onClick={() => onMove(1)} title="Nach hinten" disabled={busy || index === total - 1} testId={`scan-page-${index}-right`}>
          <ChevronRight className="w-4 h-4" />
        </IconBtn>
        <IconBtn onClick={onRemove} title="Seite entfernen" danger disabled={busy} testId={`scan-page-${index}-remove`}>
          <Trash2 className="w-4 h-4" />
        </IconBtn>
      </div>
    </div>
  </div>
);
